var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D7D3",
    d: "M7.286 7.636V4.973l2.697-1.544l7.589 4.364v2.651L14.863 12zm0 8.523v-2.61l4.649-2.62l2.928 1.656l2.709-1.525v2.335l-7.59 4.277zm2.697 2.144l-2.697-1.481v2.268l2.697 1.482l2.446-1.482v-2.137z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol);
export default __webpack_public_path__ + "static/media/pol.6684cf768ab444a4d45f8e3a1f2fd820.svg";
export { ForwardRef as ReactComponent };